import { sanitizeTodos, useLoaders, useTableFilter, useTableServerSideFiltering, useUploadFile } from "@/shared";
import { useFetchPuTrasladoInventario, useFetchTransferenciaInventariable } from "@/shared/actions/erp/inventario/transferencia-material.actions";
import { GeneralTable } from "@/shared/components/ui";
import { useTableSolicitudTransferenciaInventario } from "@/shared/hooks/useTableSolicitudTransferenciaInventario";
import { EstadoSolicitudTransferencia, IDataTrasladoInventario } from "@/shared/interfaces";
import { Grid, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { TransferenciaInventarioFiltro } from "../../transferencia-inventario/TransferenciaInventarioFiltro";

export type TransferenciaInventarioFilter = {
  producto_codigo: string | null;
  producto_serie: string | null;
  fecha_creacion_after: string;
  fecha_creacion_before: string;
}

interface TablaTransferenciaInventarioComponenteProps {
  estado: EstadoSolicitudTransferencia
}

const TablaTransferenciaInventarioComponente = ({
}: TablaTransferenciaInventarioComponenteProps) => {

  ///* form
  const form = useForm<TransferenciaInventarioFilter>({
    defaultValues: {
      producto_codigo: null,
      producto_serie: null,
      fecha_creacion_after: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      fecha_creacion_before: dayjs().format('YYYY-MM-DD')
    }
  });

  const {
    columnaTrasladoInventario
  } = useTableSolicitudTransferenciaInventario();

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const {
    descargarPdfDesdeurl
  } = useUploadFile()

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    isLoading,
    data: transferenciaProducto,
    isRefetching
  } = useFetchTransferenciaInventariable(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      //...form.getValues(),
      producto_codigo: sanitizeTodos(form.getValues().producto_codigo),
      producto_serie: sanitizeTodos(form.getValues().producto_serie),
      fecha_creacion_after: form.getValues().fecha_creacion_after,
      fecha_creacion_before: form.getValues().fecha_creacion_before,
      ...filterObject,
      filterByState: false
    }
  );


  const {
    mutateAsync: mutateAsyncPutTrasladoInventario,
    isPending
  } = useFetchPuTrasladoInventario()

  const handleDescargarPdf = async (value: IDataTrasladoInventario) => {

    const fileName = `${value.ubicacion_origen_data.nombre}_${value.ubicacion_destino_data.nombre}_${dayjs().format('YYYY-MM-DD')}`;

    let url = value.url_pdf;

    // Si no hay URL, la pedimos al backend
    if (!url) {
      try {
        const resp = await mutateAsyncPutTrasladoInventario({
          id: value.id_traslado_inventario,
          data: { url_pdf: null },
        });

        if (resp.code !== 200 || !resp.data?.url_pdf) {
          toast.info('No existe documento. [404]');
          return;
        }

        url = resp.data.url_pdf;
      } catch (error) {
        toast.info('No existe documento. [404]');
        return;
      }
    }

    // Si llegamos aquí, siempre hay una URL
    descargarPdfDesdeurl(url, fileName);
  };



  useLoaders(
    isPending
  )


  return (

    <Grid container spacing={3} sx={{ paddingTop: 2 }}>

      <TransferenciaInventarioFiltro form={form} />

      <Grid item xs={12}>

        <GeneralTable<IDataTrasladoInventario>
          columns={columnaTrasladoInventario}
          data={transferenciaProducto?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={transferenciaProducto?.data.count}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // crud
          canDelete={false}
          positionActionsColumn='first'
          canEdit={false}
          enableColumnActions={true}
          showCustomActionBtnSpace={true}
          enableManualFiltering={true}
          enableSorting={false}
          customActionBtnSpace={(value) => {
            return (
              <Grid container>
                <Grid item>
                  <IconButton onClick={async () => {
                    handleDescargarPdf(value)
                  }}>
                    <CloudDownloadIcon color="info" />
                  </IconButton>
                </Grid>


              </Grid>
            )
          }}
        />
      </Grid>
    </Grid>

  );
}


export default TablaTransferenciaInventarioComponente;